"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findWith = exports.find = void 0;

var _isMatch = require("../is-match/is-match");

/**
 * Find the first element that satisfies the matchFn
 *
 * @param  {Function} fn              Function applied to each element
 * @param  {Mixed}    notFoundDefault Return if no match found
 * @param  {Array}    source          Source array
 *
 * @return {mixed|undefined}  First element
 *
 * @example
 */
var find = function find(fn, notFoundDefault) {
  return function (source) {
    for (var i = 0, length = source.length; i < length; i++) {
      var isFound = fn(source[i], i, source);

      if (isFound === true) {
        return source[i];
      }
    }

    return notFoundDefault;
  };
};

exports.find = find;

var findWith = function findWith(subset, notFoundDefault) {
  return find((0, _isMatch.isMatch)(subset), notFoundDefault);
};

exports.findWith = findWith;